import React, { useEffect, useContext, useState} from 'react';
import axiosConfig from '../../../utils/axiosConfig';
import Cookies from 'js-cookie';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'formik-material-ui';
import ResponsiveLayout from '../../Layouts/ResponsiveLayout';
import Alert from '@material-ui/lab/Alert';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';
import { StateContext, DispatchContext } from '../../../context/Provider';
import { Box, Button, Grid, Paper, Typography } from '@material-ui/core';

const MyAccount = () => {

    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);
    const { authState } = appState;
    const { globalDispatch } = appDispatch;

    const [errorMessages, setErrorMessages] = useState([]);

    const [avatar, setAvatar] = useState('');
    const [fileUploadLabel, setFileUploadLabel] = useState(
        <><AccountCircleOutlinedIcon /><p style={{marginLeft: '5px', fontWeight: '500'}}>Select an avatar to upload (optional)</p></>
    );

    const [user, setUser] = useState({
        role: '',
        name: '',
        email: '',
        old_password: '',
        new_password: '',
        confirm_new_password: ''
    });

    async function fetchProfile() {
        try {

            const response = await axiosConfig.get(`/auth/authUser`);
            const { data } = response;

            Cookies.set('authUser', data, { sameSite: 'lax', expires: 1 });

            setUser({
                role: data.role,
                name: data.name,
                email: data.email,
                old_password: '',
                new_password: '',
                confirm_new_password: ''
            });

        } catch(e) {
            console.log(e);
        }

        globalDispatch({type: 'setIsLoading', value: false});
    }

    async function updateProfile(values, resetForm) {

        const formData = new FormData();
        formData.append('_method', 'PATCH');
        formData.append('name', values.name);
        formData.append('email', values.email);
        formData.append('old_password', values.old_password);
        formData.append('new_password', values.new_password);
        formData.append('avatar', avatar);

        try {

            const res = await axiosConfig.post(`/manage-profile/${authState.user.id}`, formData);
            if (res.data.status_code === 'ok') {
                console.log(res.data);
                setErrorMessages([]);
                globalDispatch({type: 'setSnackbarMsg', value: 'Profile updated successfully.'});
                globalDispatch({type: 'setIsOpenSnackbar', value: true});
                fetchProfile();

                setTimeout(() => {
                    window.location.reload();
                }, 500);

            } else {
                setErrorMessages([res.data.message]);
            }

        } catch (err) {
            if (err.response.status === 422) {
                const errors = err.response.data.errors;

                let errorMsgs = [];
                Object.keys(errors).map((error, index) => {
                    if (errors[error].length > 0) {
                        errors[error].map((err1, index1) => {
                            errorMsgs.push(err1);
                        });
                    } else {
                        errorMsgs.push(errors[error][0]);
                    }
                });

                setErrorMessages(errorMsgs);
            }
        }

        globalDispatch({type: 'setIsLoading', value: false});
        setTimeout(() => {
            globalDispatch({type: 'setIsOpenSnackbar', value: false});
        }, 1200);
    }

    const handleFileChange = (event) => {
        try {
            console.log(event.target.files[0].name);
            setFileUploadLabel(event.target.files[0].name);
            setAvatar(event.target.files[0]);
        } catch (e) {
            return;
        }
    }

    useEffect(() => {

        globalDispatch({type: 'setIsLoading', value: true});
        globalDispatch({type: 'setShowTabs', value: false});

        const source = axiosConfig.CancelToken.source();
        fetchProfile();
        return () => {
            source.cancel();
        }

    }, []);

    return (
        <ResponsiveLayout>
            <Box mt={2} />
            <Grid
                container
                spacing={2}
                justify="center"
            >
                { user.role && (
                    <Grid item xs={12} sm={12} md={8} lg={6} xl={6}>
                        <Paper elevation={1}>
                            <Box p={2}>
                                <Formik
                                    initialValues={user}
                                    validate={(values) => {
                                        const errors = {};

                                        if (!values.name) {
                                            errors.name = 'This field is required';
                                        }

                                        if (!values.email) {
                                            errors.email = 'This field is required';
                                        }

                                        if (values.new_password !== values.confirm_new_password) {
                                            errors.new_password = 'Passwords do not match';
                                        }

                                        return errors;
                                    }}
                                    onSubmit={(values, {setSubmitting, resetForm}) => {
                                        setSubmitting(false);
                                        globalDispatch({type: 'setIsLoading', value: true});
                                        updateProfile(values, resetForm);
                                    }}
                                >
                                    {({submitForm, isSubmitting, touched, errors}) => (
                                        <Form>
                                            <Box pt={0.3} mb={2}>
                                                <Typography variant="h6">My Account</Typography>
                                            </Box>

                                            <Grid container spacing={2}>

                                                {errorMessages.length > 0 && (
                                                    <Grid item xs={12}>
                                                        <Alert variant="filled" severity="error" style={{width: '100%'}}>
                                                            {errorMessages.map((key, i) => (
                                                                <Typography key={i}>
                                                                    {key}
                                                                </Typography>
                                                            ))}
                                                        </Alert>
                                                    </Grid>
                                                )}

                                                <Grid item xs={12}>
                                                    <Alert severity="warning">
                                                        Note: Changing your password will take effect for both SMS and LMS platforms.
                                                    </Alert>
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <Box py={1}>
                                                        <Button
                                                            variant="outlined"
                                                            size="small"
                                                            component="label"
                                                            fullWidth
                                                            type="button"
                                                            style={{justifyContent: "flex-start"}}
                                                        >
                                                            {fileUploadLabel}
                                                            <input type="file" onChange={handleFileChange} hidden />
                                                        </Button>
                                                    </Box>
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <Field
                                                        component={TextField}
                                                        label="User Role"
                                                        name="role"
                                                        fullWidth
                                                        disabled
                                                    />
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <Field
                                                        component={TextField}
                                                        label="Full Name (required)"
                                                        name="name"
                                                        fullWidth
                                                        disabled
                                                    />
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <Field
                                                        component={TextField}
                                                        label="Email (required)"
                                                        name="email"
                                                        fullWidth
                                                        disabled
                                                    />
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <Field
                                                        component={TextField}
                                                        label="Old Password"
                                                        name="old_password"
                                                        type="password"
                                                        fullWidth
                                                        autoComplete="off"
                                                    />
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <Field
                                                        component={TextField}
                                                        label="New Password"
                                                        name="new_password"
                                                        type="password"
                                                        fullWidth
                                                        autoComplete="off"
                                                    />
                                                </Grid>

                                                <Grid item xs={12}>
                                                    <Field
                                                        component={TextField}
                                                        label="Confirm New Password"
                                                        name="confirm_new_password"
                                                        type="password"
                                                        fullWidth
                                                        autoComplete="off"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Box mt={2}>
                                                <Grid container justify="flex-end">
                                                    <Button
                                                        disabled={isSubmitting}
                                                        color="primary"
                                                        variant="contained"
                                                        disableElevation
                                                        onClick={submitForm}
                                                    >
                                                        Save Changes
                                                    </Button>
                                                </Grid>
                                            </Box>

                                        </Form>
                                    )}
                                </Formik>
                            </Box>
                        </Paper>
                    </Grid>
                )}
            </Grid>
        </ResponsiveLayout>
    );
}

export default MyAccount;